module.exports = __webpack_public_path__ + "fa7248a9728200812a95d1e1aee06da8.png";